import { Button, Dropdown, type MenuProps } from 'antd'
import { MoreVertical } from 'lucide-react'

import { useStyles } from './styles'

type Props = {
  options?: MenuProps['items']
}

export const TableActions = ({ options = [] }: Props) => {
  const { styles } = useStyles()

  return (
    <Dropdown menu={{ items: options }} trigger={['click']}>
      <Button
        type="text"
        icon={<MoreVertical size={18} />}
        className={styles.button}
      />
    </Dropdown>
  )
}
